export default __webpack_public_path__ + "static/media/Beehaz_06_guests.851c4a7e.png";